import { createSelector } from 'reselect'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors/index.js'
import {
  canEditWorkoutUtil,
  getCurrentProfileSelect,
  isAdminProfileUtil
} from '@gymaholic/packages'

export default function canEditByIdWorkoutSelector (id) {
  return createSelector(
    getByIdWorkoutSelector(id),
    getCurrentProfileSelect,
    (
      workout,
      profile
    ) => (
      canEditWorkoutUtil(workout, profile) ||
      isAdminProfileUtil(profile)
    )
  )
}
